import { useEffect, useState } from "react";
import styles from './Contacts.module.css';
import { userService } from "../Services/userService";
import toast from "react-hot-toast";
import Moment from "react-moment";

const Contacts = (props) => {
  const [contacts, setContacts] = useState([]);
  const [openPanels, setOpenPanels] = useState({});

  const togglePanel = (id) => {
    setOpenPanels((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

    useEffect(() => {
      userService.getContacts().then((data) => {
        setContacts(data);
      }).catch((e) => {
        toast.error("Unable to get the Contacts");
        console.error(e);
      })
    }, []);


    return <div className={styles.panelContainer}>
            {
              contacts.map((item) => (
                <div className={styles.panel} key={item.contactUsId}>
                  <div className={styles.panelHeader}>
                    <button className={styles.toggleBtn} onClick={() => togglePanel(item.contactUsId)}>
                      {openPanels[item.contactUsId] ? "−" : "+"}
                    </button>
                    <div className={styles.summary}>
                      <span><strong>Name:</strong> {item.name}</span>
                      <span><strong>Phone:</strong> {item.phoneNo}</span>
                      <span><strong>Date:</strong> <Moment date={item.date} format={"DD-MMMM-YYYY hh:mm A"}></Moment></span>
                    </div>
                  </div>
                  {openPanels[item.contactUsId] && (
                    <div className={styles.panelBody}>
                      <div><strong>Email:</strong> {item.email}</div>
                      <div><strong>Designation:</strong> {item.designation}</div>
                      <div><strong>Industry:</strong> {item.industry}</div>
                      <div><strong>Organization Type:</strong> {item.organizationType}</div>
                      <div><strong>Page:</strong> {item.page}</div>
                      <div><strong>Element:</strong> {item.element}</div>
                      <div><strong>Location:</strong> {item.location}</div>
                      <div><strong>Message:</strong> {item.message}</div>
                    </div>
                  )}
                </div>
              ))
            }
          </div>;
}

export default Contacts;